import { styled } from "@horizontal-org/shira-ui";

export const SettingDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`